import api from "../../../../../../api";
import React from "react";
import utils from "../../../../../../utils";
import values from "../../../../../../values";
import Context from "../../../../../../context";

import {
  ICityItem,
  ICompanyItem,
  IItem,
  IOnSearchUser,
  IProvinceItem,
} from "../../../../../../types/common.interface";
import { useQuery } from "react-query";
import { useFormik } from "formik";
import { ICreateAndUpdateDriver } from "../../../../../../types/driver.interface";
import { ICreateAndUpdateCompany } from "../../../../../../types/company.interface";
import {
  CustomButton2,
  CustomDropdownMultiSearch,
  CustomDropdownSearch,
  CustomInput,
  CustomView,
} from "../../../../../../components";

import * as Yup from "yup";
import TitleLine from "../../../../../../components/TitleLine";
import validations from "../../../../../../validations";
import { useTranslation } from "react-i18next";
import { gender, marital } from "../../../../../../values/dropdownItems";

type Props = {
  defaultValues: ICreateAndUpdateDriver;
  onSubmit: (event: ICreateAndUpdateDriver) => void;
};

const SuperAgentDriverInformation = (props: Props) => {
  const { isLoading, setShowModal } = React.useContext(Context.DriverScreen);
  const [selectedGender, setSelectedGender] = React.useState<IItem | undefined>(
    props?.defaultValues?.gender
  );
  const [selectedMarital, setSelectedMarital] = React.useState<
    IItem | undefined
  >(props?.defaultValues?.marital);
  const [selectedCompany, setSelectedCompany] = React.useState<
    ICreateAndUpdateCompany | undefined
  >(props?.defaultValues?.company);
  // const [selectedCity, setSelectedCity] = React.useState<ICityItem>();
  // const [selectedProvince, setSelectedProvince] =
  //   React.useState<IProvinceItem>();
  const [searchedValue, setSearchedValue] = React.useState<IOnSearchUser>();
  const [dropDownErrors, setDropDownErrors] = React.useState<any>({
    province: "",
    city: "",
    gender: "",
    marital: "",
    company: "",
  });

  // !! ===========================================================================================================
  // !!                                            Start API Call
  // !! -----------------------------------------------------------------------------------------------------------
  // const getAllProvince = useQuery([values.useQueryKeys.getAllProvince], () =>
  //   api.get.common.getAllProvince()
  // );
  // const getAllCity = useQuery(
  //   [values.useQueryKeys.getAllCity, selectedProvince],
  //   () => api.get.common.getAllCity({ provinceCode: selectedProvince?.Code })
  // );

  // !! ===========================================================================================================
  // !!                                            Start API Call
  // !! -----------------------------------------------------------------------------------------------------------
  const getAllCompany = useQuery(
    [values.useQueryKeys.getAllCompany, searchedValue],
    () =>
      api.post.superAgent.findCompany({
        search: {
          base: searchedValue?.base?.value,
          value: searchedValue?.searchedValue,
        },
      })
  );
  // !! -----------------------------------------------------------------------------------------------------------
  // !!                                             End API Call
  // !! ===========================================================================================================

  // ?? ===========================================================================================================
  // ??                                           Use Formik Function
  // ?? -----------------------------------------------------------------------------------------------------------
  const formik = useFormik<ICreateAndUpdateDriver>({
    enableReinitialize: true,
    initialValues: {
      address: props?.defaultValues?.address,
      lastName: props?.defaultValues?.lastName,
      firstName: props?.defaultValues?.firstName,
      kartNumber: props?.defaultValues?.kartNumber,
      phoneNumber: props?.defaultValues?.phoneNumber,
      shabaNumber: props?.defaultValues?.shabaNumber,
      nationalCode: props?.defaultValues?.nationalCode,
    },
    validationSchema: Yup.object({
      address: validations.yupValidations.address,
      lastName: validations.yupValidations.lastName,
      firstName: validations.yupValidations.firstName,
      kartNumber: validations.yupValidations.kartNumber,
      phoneNumber: validations.yupValidations.phoneNumber,
      shabaNumber: validations.yupValidations.shabaNumber,
      nationalCode: validations.yupValidations.nationalCode,
    }),
    onSubmit: (values: ICreateAndUpdateDriver, { setSubmitting }) => {
      // if (!selectedCompany) return utils.errorHandler(9013);
      const formValues: ICreateAndUpdateDriver = {
        ...values,
        gender: selectedGender,
        company: selectedCompany,
        marital: selectedMarital,
        // city: selectedCity?._id,
        // province: selectedProvince?._id,
      };
      if (
        // selectedProvince &&
        // selectedCity &&
        selectedCompany &&
        selectedMarital &&
        selectedGender
      ) {
        Promise.resolve(props.onSubmit(formValues)).catch((e) =>
          setSubmitting(false)
        );
      }
    },
  });

  const { t } = useTranslation();

  const submitHandler = () => {
    let dropDownErrorsList = {
      // province: "",
      // city: "",
      gender: "",
      marital: "",
      company: "",
    };
    if (!selectedGender) {
      dropDownErrorsList = {
        ...dropDownErrorsList,
        gender: t("gender_is_required"),
      };
    }
    if (!selectedMarital) {
      dropDownErrorsList = {
        ...dropDownErrorsList,
        marital: t("marital_is_required"),
      };
    }
    if (!selectedCompany) {
      dropDownErrorsList = {
        ...dropDownErrorsList,
        company: t("company_is_required"),
      };
    }

    // if (!selectedProvince) {
    //   dropDownErrorsList = {
    //     ...dropDownErrorsList,
    //     province: "انتخاب استان اجباری است",
    //     city: "انتخاب شهر اجباری است",
    //   };
    // } else if (!selectedCity) {
    //   dropDownErrorsList = {
    //     ...dropDownErrorsList,
    //     city: "انتخاب شهر اجباری است",
    //   };
    // }

    setDropDownErrors(dropDownErrorsList);

    formik.submitForm();
  };

  // ?? ===========================================================================================================
  // ??                                              JSX Content
  // ?? -----------------------------------------------------------------------------------------------------------
  const companyInformationWithCompanyName = getAllCompany?.data?.result?.map(
    (item: any) => ({
      ...item,
      companyName: item?.companyInformation?.companyName,
    })
  );

  const companyPropertyPath =
    values.dropdownBaseSearch.COMPANY_BASE_SEARCH_SUPERAGENT_ROLE.map(
      (item) => {
        switch (item.value) {
          case "COMPANY_NAME":
            return { ...item, value: "companyName", base: "COMPANY_NAME" };
          case "PHONE_NUMBER":
            return { ...item, value: "phoneNumber", base: "PHONE_NUMBER" };
          case "FIRST_NAME":
            return { ...item, value: "firstName", base: "FIRST_NAME" };
          case "LAST_NAME":
            return { ...item, value: "lastName", base: "LAST_NAME" };
          case "NATIONAL_CODE":
            return {
              ...item,
              value: "companyInformation.nationalCode",
              base: "NATIONAL_CODE",
            };
        }
      }
    );

  return (
    <form onSubmit={submitHandler}>
      <CustomView.Container className="create-form-content">
        <TitleLine title={t("driverInfo")} />
        <CustomView.Row className="form-row">
          <CustomView.Column medium={6} className="form-colum dropdown">
            <label className="form-label">{t("company")}</label>
            <CustomDropdownMultiSearch
              isSearch
              baseSearch={values.dropdownBaseSearch.COMPANY_BASE_SEARCH_SUPERAGENT_ROLE.map(
                (item) => ({
                  ...item,
                  title: t(item.title),
                })
              )}
              items={companyInformationWithCompanyName}
              itemName="companyName"
              onSelectItem={(event: ICompanyItem) => {
                setSelectedCompany(event);
                setDropDownErrors({ ...dropDownErrors, company: "" });
              }}
              defaultItem={selectedCompany}
              searchedValue={searchedValue}
              setSearchedValue={setSearchedValue}
              placeHolder={t("selectCompany")}
              isLoading={getAllCompany.isLoading}
              selectedBaseSearch={
                companyPropertyPath.find(
                  (item) => item?.base === searchedValue?.base.value
                )?.value
              }
            />
            <div className="error">
              {dropDownErrors.company !== "" && dropDownErrors.company}
            </div>
          </CustomView.Column>
          <CustomView.Column medium={6} className="form-colum dropdown">
            <CustomInput
              name="phoneNumber"
              id="phoneNumber"
              label={t("phoneNumber")}
              value={formik.values.phoneNumber}
              onValueChange={formik.handleChange}
              formikProps={{ onBlur: formik.handleBlur }}
              error={formik.errors.phoneNumber && formik.touched.phoneNumber}
              errorText={formik.errors.phoneNumber}
              maxLength={11}
            />
          </CustomView.Column>
        </CustomView.Row>
        <CustomView.Row className="form-row">
          <CustomView.Column medium={6} className="form-colum">
            <CustomInput
              name="firstName"
              id="firstName"
              label={t("firstName")}
              value={formik.values.firstName}
              onValueChange={formik.handleChange}
              formikProps={{ onBlur: formik.handleBlur }}
              error={formik.errors.firstName && formik.touched.firstName}
              errorText={formik.errors.firstName}
            />
          </CustomView.Column>
          <CustomView.Column medium={6} className="form-colum">
            <CustomInput
              name="lastName"
              id="lastName"
              label={t("lastName")}
              value={formik.values.lastName}
              onValueChange={formik.handleChange}
              formikProps={{ onBlur: formik.handleBlur }}
              error={formik.errors.lastName && formik.touched.lastName}
              errorText={formik.errors.lastName}
            />
          </CustomView.Column>
        </CustomView.Row>
        {/* <CustomView.Row className="form-row">
          <CustomView.Column medium={6} className="form-colum dropdown">
            <label className="form-label">استان</label>
            <CustomDropdownSearch
              items={getAllProvince?.data?.result}
              itemName="Name"
              defaultItem={selectedProvince}
              onSelectItem={(event: IProvinceItem) => {
                setSelectedProvince(event);
                setDropDownErrors({ ...dropDownErrors, province: "" });
              }}
              placeHolder="انتخاب استان"
              isLoading={getAllProvince.isLoading}
              isSearch
            />
            <div className="error">
              {dropDownErrors.province !== "" && dropDownErrors.province}
            </div>
          </CustomView.Column>
          <CustomView.Column medium={6} className="form-colum dropdown">
            <label className="form-label">شهر</label>
            <CustomDropdownSearch
              items={getAllCity?.data?.result}
              itemName="Name"
              defaultItem={selectedCity}
              onSelectItem={(event: ICityItem) => {
                setSelectedCity(event);
                setDropDownErrors({ ...dropDownErrors, city: "" });
              }}
              placeHolder="انتخاب شهر"
              isLoading={getAllCity.isLoading}
              isSearch
            />
            <div className="error">
              {dropDownErrors.city !== "" && dropDownErrors.city}
            </div>
          </CustomView.Column>
        </CustomView.Row> */}

        <CustomView.Row className="form-row">
          <CustomView.Column medium={6} className="form-colum dropdown">
            <label className="form-label">{t("gender")}</label>

            <CustomDropdownSearch
              items={gender.map((item) => {
                return { ...item, name: t(item.name as string) };
              })}
              itemName="name"
              placeHolder={t("selectGender")}
              defaultItem={selectedGender}
              onSelectItem={(event: any) => {
                setSelectedGender(event);
                setDropDownErrors({ ...dropDownErrors, gender: "" });
              }}
            />
            <div className="error">
              {dropDownErrors.gender !== "" && dropDownErrors.gender}
            </div>
          </CustomView.Column>
          <CustomView.Column medium={6} className="form-colum dropdown">
            <label className="form-label">{t("marital")}</label>

            <CustomDropdownSearch
              items={marital.map((item) => {
                return { ...item, name: t(item.name as string) };
              })}
              itemName="name"
              placeHolder={t("selectMarital")}
              defaultItem={selectedMarital}
              onSelectItem={(event: any) => {
                setSelectedMarital(event);
                setDropDownErrors({ ...dropDownErrors, marital: "" });
              }}
            />
            <div className="error">
              {dropDownErrors.marital !== "" && dropDownErrors.marital}
            </div>
          </CustomView.Column>
        </CustomView.Row>

        <CustomView.Row className="form-row">
          <CustomView.Column medium={6} className="form-colum">
            <CustomInput
              name="nationalCode"
              id="nationalCode"
              label={t("nationalCode")}
              value={formik.values.nationalCode}
              onValueChange={formik.handleChange}
              formikProps={{ onBlur: formik.handleBlur }}
              error={formik.errors.nationalCode && formik.touched.nationalCode}
              errorText={formik.errors.nationalCode}
              maxLength={10}
            />
          </CustomView.Column>
          <CustomView.Column medium={6} className="form-colum">
            <CustomInput
              name="kartNumber"
              id="kartNumber"
              label={t("cardNumber")}
              value={formik.values.kartNumber}
              onValueChange={formik.handleChange}
              formikProps={{ onBlur: formik.handleBlur }}
              error={formik.errors.kartNumber && formik.touched.kartNumber}
              errorText={formik.errors.kartNumber}
              maxLength={16}
            />
          </CustomView.Column>
        </CustomView.Row>
        <CustomView.Row className="form-row">
          <CustomView.Column medium={6} className="form-colum">
            <CustomInput
              name="address"
              id="address"
              label={t("address")}
              value={formik.values.address}
              onValueChange={formik.handleChange}
              formikProps={{ onBlur: formik.handleBlur }}
              error={formik.errors.address && formik.touched.address}
              errorText={formik.errors.address}
            />
          </CustomView.Column>
          <CustomView.Column medium={6} className="form-colum">
            <CustomInput
              name="shabaNumber"
              id="shabaNumber"
              label={t("shabaNumber")}
              value={formik.values.shabaNumber}
              onValueChange={formik.handleChange}
              formikProps={{ onBlur: formik.handleBlur }}
              error={formik.errors.shabaNumber && formik.touched.shabaNumber}
              errorText={formik.errors.shabaNumber}
              isShaba
              maxLength={24}
            />
          </CustomView.Column>
        </CustomView.Row>
        <CustomView.Row className="form-row">
          <CustomView.Column
            large={3}
            medium={4}
            small={6}
            className="form-colum"
          >
            <CustomButton2
              isLoading={isLoading}
              onClick={() => setShowModal!("NONE")}
              title={t("cancel")}
              type="danger"
            />
          </CustomView.Column>
          <CustomView.Column
            large={3}
            medium={4}
            small={6}
            className="form-colum"
          >
            <CustomButton2
              isLoading={isLoading}
              onClick={submitHandler}
              title={t("next")}
            />
          </CustomView.Column>
        </CustomView.Row>
      </CustomView.Container>
    </form>
  );
};

export default SuperAgentDriverInformation;
